import {
  defineNuxtPlugin,
  useRequestURL,
} from '#imports';

const previewParams = [
  'token',
  'x-craft-preview',
  'x-craft-live-preview',
];

/**
 * Adds Craft preview params from the current request to the GraphQL endpoint.
 *
 * @param {String} endpoint
 * @param {URL} currentUrl
 * @returns {String}
 */
export const withPreviewParams = (endpoint, currentUrl) => {
  const url = new URL(endpoint);

  previewParams.forEach((param) => {
    if (currentUrl.searchParams.has(param)) {
      url.searchParams.set(param, currentUrl.searchParams.get(param));
    }
  });

  return url.toString();
};

/**
 * Craft preview requires token params on GraphQL requests so drafts resolve.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const currentUrl = import.meta.server ? useRequestURL() : new URL(window.location.href);
  const hasPreviewParams = previewParams.some((param) => currentUrl.searchParams.has(param));

  if (!hasPreviewParams) {
    return;
  }

  const applyPreviewEndpoint = () => {
    // nuxt-graphql-client keeps the GraphQLClient instance in app state.
    // eslint-disable-next-line no-underscore-dangle
    const client = nuxtApp._gqlState?.value?.default?.instance;

    client?.setEndpoint(withPreviewParams(client.url, currentUrl));
  };

  applyPreviewEndpoint();
  nuxtApp.hook('app:created', applyPreviewEndpoint);
});
